/* Réglages de la visite. Ce fichier se modifie à la main, sans toucher au reste du code. */
window.VISITE_CONFIG = {
  // 'sur-demande' : le mode travail s'ouvre en ajoutant ?mode=travail à l'adresse.
  // 'jamais'      : le mode travail est retiré. C'est le réglage de la version publique.
  // Ce réglage masque un outil, il ne protège rien : les images restent publiques.
  modeTravail: 'jamais',

  // true  : la visite attend un clic sur « Commencer la visite » avant de charger les images.
  //         La page qui accueille la visite reste légère tant que personne ne clique.
  // false : la visite démarre toute seule.
  ecranAccueil: true,

  // Identifiant de la capture d'origine, écrit dans les fichiers d'indications exportés.
  apercu: true,

  // Vide : images dans fichiers/ à côté de la page d'essai.
  baseImages: 'https://hedayatmusic.com/cdn/shop/files/',

  modele: 'MnxHQ6hvpPH',

  // Page avec le menu du site : seule adresse à modifier pour l’intégration et le partage.
  pageIntegree: 'https://hedayatmusic.com/pages/visite-virtuelle-du-studio',
  get lienPartage() { return this.pageIntegree; },
  set lienPartage(adresse) { this.pageIntegree = adresse; },

  // Note confirmée par Hedayat le 21/10/2026. Une seule valeur à modifier ici.
  commerce: {
    noteGoogle: '4,9',
    nombreAvis: 287,
    avisGoogle: 'https://search.google.com/local/reviews?placeid=ChIJYfoZa5Jj5kcRow80WO5lv4g',
    reservation: {
      studioA: 'https://hedayatmusic.com/products/studio-a-seance-denregistrement',
      studioB: 'https://hedayatmusic.com/products/studio-b-seance-denregistrement',
      autres: 'https://hedayatmusic.com/pages/nos-studios'
    },
    rendezVous: 'https://hedayatmusic.com/products/rendez-vous-avec-hedayat',
    telephone: 'tel:+33184200143'

  }
};

window.VISITE_COMMERCE = {
  lienSeance(point, config = window.VISITE_CONFIG.commerce) {
    const nom = point?.label || '';
    const type = ['Studio A', 'Cabine du studio A', 'Accès au studio A'].includes(nom) ? 'studioA'
      : ['Studio B', 'Cabine du studio B'].includes(nom) ? 'studioB' : 'autres';
    return config.reservation[type];
  }
};

// Un lien partageable conserve la vue, sans reprendre les paramètres de travail locaux.
window.VISITE_PARTAGE = {
  adresse(base, actuelle, numero) {
    const url = new URL(base || actuelle, actuelle);
    if (!['https:', 'http:'].includes(url.protocol)) throw new Error('Adresse de partage invalide');
    if (!base) for (const cle of ['mode', 'essai', 'direct']) url.searchParams.delete(cle);
    url.hash = 'point-' + numero;
    return url.href;
  }
};

window.VISITE_INTEGRATION = {
  destination(fenetre = window, config = window.VISITE_CONFIG) {
    const actuelle = new URL(fenetre.location.href);
    if (fenetre.self !== fenetre.top || actuelle.hostname !== 'hedayatmusic.com' ||
        actuelle.pathname.replace(/\/$/, '') !== '/pages/visite-360' ||
        actuelle.searchParams.has('direct') || !config.pageIntegree) return null;
    const cible = new URL(config.pageIntegree);
    if (cible.origin !== actuelle.origin || cible.pathname === actuelle.pathname) return null;
    cible.hash = /^#point-\d+$/.test(actuelle.hash) ? actuelle.hash : '';
    return cible.href;
  },
  renvoyer(fenetre = window) {
    const destination = this.destination(fenetre);
    if (!destination) return false;
    fenetre.location.replace(destination);
    return true;
  },
  actualiserAdresse(numero, fenetre = window) {
    const remplacer = cible => {
      const url = new URL(cible.location.href);
      url.hash = 'point-' + numero;
      cible.history.replaceState(cible.history.state, '', url.href);
    };
    try { remplacer(fenetre); } catch (_) { /* Un cadre restreint ne bloque pas la visite. */ }
    try {
      if (fenetre.parent !== fenetre && fenetre.parent.location.origin === fenetre.location.origin)
        remplacer(fenetre.parent);
    } catch (_) { /* Aucun accès à une page parente d’une autre origine. */ }
  }
};
